import gql from 'graphql-tag';

export const EVENT_FRAGMENT = gql`
  fragment EventFields on CalendarEventViewModel {
    id
    type
    parentId
    directionType
    activityStatus
    createdDateTime
    updatedDateTime

    endAt
    allDay
    subject
    startAt
    endDate
    eventType
    startDate
    accountId
    description
    owner {
      id
      fullName
    }

    account {
      id
      name
      portalType
    }

    due {
      dueAt
      isOverdue
      secondsSinceDue
      secondsUntilDue
    }

    participants {
      id
      fullName
      participationType
      account {
        id
        name
      }
    }

    priority
    completedAt
    isCompleted
    isOwnEvent
  }
`;
